// Tramos IRPF (2025, estatal + autonómica media aproximada). Mismos tramos que el
// funnel de onboarding B2C (b2c-onboarding/src/lib/irpf.ts) para que el ahorro fiscal
// mostrado sea coherente entre el onboarding y la plataforma.

export const IRPF_BRACKETS = [
	{ min: 0, max: 12_450, rate: 0.19 },
	{ min: 12_450, max: 20_200, rate: 0.24 },
	{ min: 20_200, max: 35_200, rate: 0.3 },
	{ min: 35_200, max: 60_000, rate: 0.37 },
	{ min: 60_000, max: 300_000, rate: 0.45 },
	{ min: 300_000, max: Infinity, rate: 0.47 }
] as const;

/** Cuota íntegra IRPF (progresiva) y tipo efectivo para una base imponible dada. */
export function calculateIRPF(baseImponible: number): { total: number; effectiveRate: number } {
	let tax = 0;
	let remaining = baseImponible;
	for (const bracket of IRPF_BRACKETS) {
		if (remaining <= 0) break;
		const width = bracket.max - bracket.min;
		const taxable = Math.min(remaining, width);
		tax += taxable * bracket.rate;
		remaining -= taxable;
	}
	return { total: tax, effectiveRate: baseImponible > 0 ? tax / baseImponible : 0 };
}
